import LocalStorage from '../local_data';
import Event from './Event';

class UpdateDiscountCode extends Event {
    eventName = 'oms_updateDiscountCode';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Set Discount Code
     * 
     * @param {string} data.discount_code -  discount code
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let discountCode = data.discount_code;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        if (clientId && (discountCode !== undefined)) {
            let currentLocation = new LocalStorage.CurrentLocation(clientId).getData();
            let discountCodeData = new LocalStorage.DiscountCode(currentLocation);
            discountCodeData.setData(discountCode);

            thisObj.onSuccessEvent({
                "auth_type": "public", 
                "data": data,
                "data_type": "local",  
                "success" : true, 
                "message" : "" 
            },
            {
                'action' : action, 
                'request_id' : requestId 
            });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "client_id & discount_code is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default UpdateDiscountCode;